import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReportCategory, Approver, ReportMetadata, VoluntaryReportMetadata, ReportSchedule } from '../../models/report.model';
import { Location, User } from '../../models/user.model';
import { LookupService } from '../../services/lookups/lookup.service';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { SelectItem, Tree } from 'primeng/primeng';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { environment } from '../../../environments/environment';
import { NotifierService } from 'angular-notifier';
import { TreeNode } from 'primeng/api';
import { debug } from 'util';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-voluntaryrptmetadata',
  templateUrl: './voluntaryrptmetadata.component.html',
  styleUrls: ['./voluntaryrptmetadata.component.css']
})
export class VoluntaryrptmetadataComponent implements OnInit {
  voluntaryMetadataForm: FormGroup;
  voluntaryMetadata: VoluntaryReportMetadata;

  reportCategories: ReportCategory[] = [];

  reportCategoriesTree: TreeNode[];
  selectedCategoryNodes: TreeNode[] = new Array<TreeNode>();
  selectedReportCategories: ReportCategory[] = new Array<ReportCategory>();

  //TODO: Get this data from WEBAPI
  distributionTypes: SelectItem[] = [{ label: 'Public', value: 'Public' }, { label: 'Internal', value: 'Internal' }];
  countries: Location[] = [];
  posts: Location[] = [];
  //approvers : Approver[]=[];
  approvers: User[] = [];
  accessLink: string;
  launchStatus: boolean = false;
  reportScheduleforStatus: ReportSchedule;
  currentUser: User;
  loading:boolean=false;

  @Output() showHideMetadata = new EventEmitter<boolean>();
  @Input() reportId: any;
  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private authUser: AuthUserService,
    private reportDashboardService: ReportdashboardService,
    private notifier: NotifierService
  ) {}

  /* Sample reg ex for allow alpha numeric and special charecteres /^[ A-Za-z0-9_@./#&+-]*$/ */
  ngOnInit() {
    this.voluntaryMetadataForm = this.fb.group({
      Id: [''],
      reportNumber: [''],
      reportDate: [new Date()],
      country: ['', Validators.required],
      post: ['', Validators.required],
      region: [''],
      //reportName: ['', [Validators.required,Validators.pattern(/^(?![\s\S]*[^\w -]+)[\s\S]*?$/)]],
      
      reportName: ['', [Validators.required,Validators.pattern(/^[ A-Za-z0-9_'-]*$/)]],
      reportCategory: ['', Validators.required],
      distributionType: ['', Validators.required],
      preparedBy: [''],
      approvedBy: ['', Validators.required],
      reportHighlights: ['', Validators.maxLength(1024)],
      disclaimer: [''],
      reportState: ['']
    });

    this.launchStatus = false;
       this.currentUser = this.authUser._user;
      // console.log("User Role Details=================" + JSON.stringify(this.currentUser.userRoles[1].roleName));
  }
  loadReportCategories() {
    this.loading = true;
    this.lookupService.getAllReportCategories$().subscribe(data => {
      this.reportCategories = data;
    });

    
    this.lookupService.getReportCategoryHierarchy$(false)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe(categories => {
      console.log(categories);
      this.reportCategoriesTree = Array.of(categories);
      this.reportCategoriesTree[0].children.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
     this.reportCategoriesTree[0].expanded= true;
    });
  }
  
  showMetadataDialog(id: any) {
    // console.log(id);
    //this.lookupService.getRootLocations(this.authUser._user.userType.typeName).subscribe((data: Location[]) => {
      this.lookupService.getAllCountries$().subscribe((data: Location[]) => {
      this.countries = data;
      this.countries.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
    this.loadReportCategories();


    if (id == null) {
      this.voluntaryMetadataForm.reset();
      this.voluntaryMetadataForm.enable();
      this.voluntaryMetadataForm.patchValue({
        preparedBy: this.authUser._user.firstName + ' ' + this.authUser._user.lastName,
        reportDate: new Date()
      });
      this.launchStatus = false;
    } else 
    {
      this.launchStatus = true;
      this.LoadVoluntaryMetadataForm(id);
    }

     
    this.showHideMetadata.emit(true);
  }

  loadSelectedCategoryNodes(reportMetadata: VoluntaryReportMetadata) {
    this.selectedCategoryNodes = new Array<TreeNode>();
    reportMetadata.reportCategory.forEach(reportCategory => {
      this.reportCategoriesTree[0].children.forEach(categoryNode => {
        if (categoryNode.children != null && categoryNode.children.length != 0) {
          categoryNode.children.forEach(child => {
            if (child.data == reportCategory.id) {
              this.selectedCategoryNodes.push(child);
            }
          });
        }
        if (categoryNode.data == reportCategory.id) {
          this.selectedCategoryNodes.push(categoryNode);
        }
      });
    });
  }

  LoadVoluntaryMetadataForm(id: any) {
    this.reportDashboardService.getReportScheduleById(id).subscribe((reportMetadata: VoluntaryReportMetadata) => {
      // console.log(reportMetadata);
      this.voluntaryMetadata = reportMetadata;

      // this.loadReportCategories();
      this.onChangeCountry(reportMetadata.country);
      //this.onChangePost(reportMetadata.post);

      this.loadSelectedCategoryNodes(reportMetadata);

      this.voluntaryMetadataForm.patchValue({
        Id: reportMetadata.id,
        reportName: reportMetadata.reportName,
        reportNumber: reportMetadata.reportNumber,
        reportCategory: reportMetadata.reportCategory,
        reportDate: new Date(reportMetadata.reportDate.toString()),
        reportHighlights: reportMetadata.reportHighlights,
        disclaimer: reportMetadata.disclaimer,
        distributionType: reportMetadata.distributionType,
        approvedBy: reportMetadata.approvedBy,
        country: reportMetadata.country,
        post: reportMetadata.post,
        preparedBy: reportMetadata.preparedBy,
        reportState: reportMetadata.reportState
      });

      if (reportMetadata.isReportLocked) {
        this.voluntaryMetadataForm.disable();
      } else {
        this.voluntaryMetadataForm.enable();
      }
    });
  }

  CancelReportMetadataDialog() {
    //console.log("CancelReportMetadataDialog");
    this.selectedCategoryNodes = new Array<TreeNode>();
    this.selectedReportCategories = new Array<ReportCategory>();
    this.showHideMetadata.emit(false);
  }
  onChangeCountry(selectedCountry: Location) {
    //console.log(selectedCountry);
    this.lookupService.getParentLocation(selectedCountry.id).subscribe((parentLoc: Location) => {
      //console.log(parentLoc);
      this.voluntaryMetadataForm.patchValue({ region: parentLoc.locationName });
    });
    this.lookupService.getChildLocations(selectedCountry.id).subscribe((data: Location[]) => {
      this.posts = data;
      this.posts.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
      //this.onChangePost(this.posts[0]);
    });
  }
  // onChangePost(selectedPost:any)
  // {
  //   // this.lookupService.getPostApprovers(selectedPost.id).subscribe((data:Approver[])=>{
  //   //   //console.log(data);
  //   //   this.approvers = data;
  //   // });
  // }

  SaveReportMetadata() {
    if (this.voluntaryMetadataForm.valid) {
      let reportMetadata = Object.assign(new VoluntaryReportMetadata(), this.voluntaryMetadataForm.value);
      // let reportMetadata = new VoluntaryReportMetadata();
      //console.log(this.voluntaryMetadataForm.value['approvedBy']);

      // console.log("REPORT METADATA 123456789=============" +  reportMetadata);

      this.reportDashboardService.saveVoluntaryReport$(reportMetadata).subscribe(resp => {
        //console.log(resp.body);
        this.LoadVoluntaryMetadataForm(resp.body);
        if (resp.ok) {
          //alert('Saved Successfully');
          this.notifier.notify('success', 'Voluntary Report saved successfully');
          this.launchStatus = true;
        }
      });
      //this.onSaveComplete();
    } else if (!this.voluntaryMetadataForm.dirty) {
      //this.onSaveComplete();
    }
  }
  private setVoluntaryFormsReportCategories() {
    this.voluntaryMetadataForm.controls['reportCategory'].setValue(this.selectedReportCategories);
  }
  private setSelectedReportCategories() {
    this.selectedReportCategories = new Array<ReportCategory>();
    this.selectedCategoryNodes.forEach(node => {
      if (node.children.length == 0) {
        let category = this.getReportCategoryFromNode(node);
        this.selectedReportCategories.push(category);
      }
    });
  }
  private getReportCategoryFromNode(categoryNode: TreeNode): ReportCategory {
    return this.reportCategories.filter(cat => cat.id == categoryNode.data)[0];
  }
  onCategorySelection($event) {
    this.setSelectedReportCategories();
    this.setVoluntaryFormsReportCategories();
  }
  onCategoryUnselection($event) {
    this.setSelectedReportCategories();
    this.setVoluntaryFormsReportCategories();
  }
  onSaveComplete() {
    this.voluntaryMetadataForm.reset();
    this.showHideMetadata.emit(false);
  }
  LaunchReport(Id: any) {
    //console.log(Id);
    this.reportDashboardService.getReportScheduleById(Id).subscribe((metadata:ReportSchedule)=>{
          this.reportScheduleforStatus = metadata;
    this.reportDashboardService.launchReport(Id).subscribe(data => {
      // console.log(data);
      if (this.reportScheduleforStatus.reportState == 'Approved And Sent To Washington' || this.reportScheduleforStatus.reportState == 'Hold')
      { 
        if (this.currentUser.userRoles[1].roleName == 'Admin'){ 
            this.accessLink ="ms-word:ofe|u|"+ environment.serverUrl+"/"+ data; }
        else{
            this.accessLink = environment.serverUrl+"/"+ data; }  
      }
      else
      {      this.accessLink = 'ms-word:ofe|u|' + environment.serverUrl + '/' + data; }
      const link = document.createElement('a');
      link.href = this.accessLink;
      link.setAttribute('visibility', 'hidden');
      link.click();
      //TODO: The above code is not working for IE but works for Chorme
      //window.open(this.accessLink);
    });
    });
    //this.voluntaryMetadataForm.disable();
    //console.log(this.accessLink);
  }
  filterNames(event) {
    //console.log(event);
    var searchString: string = event.query;
    this.lookupService.getAllActiveUsers$().subscribe(data => {
      this.approvers = data.map(u => u).filter(u => u.fullName.toLowerCase().includes(searchString.toLowerCase()));
      //console.log(this.ApproverNamesList);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reportdashboard/voluntaryrptmetadata/voluntaryrptmetadata.component.ts